import { AfterViewInit, Component, ElementRef, HostListener, inject, OnInit, ViewChild } from '@angular/core';
import { SimplebarAngularComponent, SimplebarAngularModule } from 'simplebar-angular';
import { Header } from '../components/header/header';
import { CustomSlide } from '../components/custom-slide/custom-slide';
import { About } from '../components/about/about';
import { Partners } from '../components/partners/partners';
import { History } from '../components/history/history';
import { News } from '../components/news/news';
import { Footer } from '../components/footer/footer';
import { AppService } from '../../services/app.service';
import { MenuType } from '../../enum/app.enum';
import { Button } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { TranslatePipe } from '@codeandweb/ngx-translate';
import { Members } from '../components/members/members';

@Component({
  selector: 'app-main',
  imports: [SimplebarAngularModule, Header, CustomSlide, About, Partners, History, News, Footer, Button, Dialog, TranslatePipe, Members],
  templateUrl: './main.html',
  styleUrl: './main.scss',
  standalone: true
})
export class Main implements OnInit, AfterViewInit {
  @ViewChild('simpleBar') simplebar!: SimplebarAngularComponent;
  @ViewChild('about', { read: ElementRef }) about!: ElementRef;
  @ViewChild('members', { read: ElementRef }) members!: ElementRef;
  @ViewChild('history', { read: ElementRef }) history!: ElementRef;
  @ViewChild('news', { read: ElementRef }) news!: ElementRef;
  public appService = inject(AppService);
  public slideImgHeight: number = 1080;
  private isResizing = false;
  private startY = 0;
  private startHeight = 0;

  async ngOnInit() {
    this.setSlideImgHeight();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const scrollEl = this.simplebar?.SimpleBar?.getScrollElement();

      this.appService.mainHomeScrollElement = scrollEl;
      if (!scrollEl) {
        return;
      }

      this.appService.homeAboutTop = this.about.nativeElement.offsetTop;
      this.appService.homeMembersTop = this.members.nativeElement.offsetTop;
      this.appService.homeHistoryTop = this.history.nativeElement.offsetTop;
      this.appService.homeNewsTop = this.news.nativeElement.offsetTop;

      scrollEl.addEventListener('scroll', async () => {
        this.getCurrentScrollMenu(scrollEl.scrollTop + scrollEl.clientHeight);
      });
    }, 500);
  }

  @HostListener('window:resize') async onResize() {
    this.setSlideImgHeight();
  }

  setSlideImgHeight(): void {
    if (window.innerWidth > 1024) {
      this.slideImgHeight = window.innerHeight < 768 ? 688 : window.innerHeight - 80;
    } else if (window.innerWidth <= 1024 && window.innerWidth > 767) {
      this.slideImgHeight = window.innerHeight < 768 ? 704 : window.innerHeight - 64;
    } else {
      this.slideImgHeight = window.innerHeight < 568 ? 504 : window.innerHeight - 64;
    }
  }

  getCurrentScrollMenu(currentScroll: number) {
    this.appService.homeAboutTop = this.about.nativeElement.offsetTop;
    this.appService.homeMembersTop = this.members.nativeElement.offsetTop;
    this.appService.homeHistoryTop = this.history.nativeElement.offsetTop;
    this.appService.homeNewsTop = this.news.nativeElement.offsetTop;

    if (currentScroll >= this.appService.homeNewsTop + window.innerHeight / 1.5) {
      this.appService.currentMenu = MenuType.News;
    } else if (currentScroll >= this.appService.homeHistoryTop + window.innerHeight / 1.5) {
      this.appService.currentMenu = MenuType.History;
    } else if (currentScroll >= this.appService.homeMembersTop + window.innerHeight / 1.5) {
      this.appService.currentMenu = MenuType.Member;
    } else {
      this.appService.currentMenu = MenuType.About;
    }
  }

  onPointerDown(event: PointerEvent): void {
    event.preventDefault();
    event.stopPropagation();

    this.isResizing = true;
    this.startY = event.clientY;
    document.addEventListener('pointermove', this.onDocumentPointerMove);
    document.addEventListener('pointerup', this.onDocumentPointerUp);
    document.addEventListener('pointercancel', this.onDocumentPointerUp); // 예상치 못한 중단 처리
  }

  onDocumentPointerMove = (event: PointerEvent): void => {
    event.preventDefault();
    event.stopPropagation();

    if (!this.isResizing) return;

    const deltaY = event.clientY - this.startY;
    const newHeight = this.startHeight - deltaY;

    this.updateHeight(newHeight);
  };

  onDocumentPointerUp = (event: PointerEvent): void => {
    event.preventDefault();
    event.stopPropagation();

    if (this.isResizing) {
      this.isResizing = false;

      document.removeEventListener('pointermove', this.onDocumentPointerMove);
      document.removeEventListener('pointerup', this.onDocumentPointerUp);
      document.removeEventListener('pointercancel', this.onDocumentPointerUp);
    }
  };

  private updateHeight(height: number): void {
    // this.changedHeight.emit(height);
  }
}
